<template>
  <div>
    <p :class="$style.deviceNumber">
      {{ numberOfDevices }}
    </p>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';

const systemGroupModel = StoreModelMap[ItemTypeConsts.systemGroup];

export default {
  name: 'DeviceCount',

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  data: () => ({
    numberOfDevices: 0,
  }),

  computed: {
    ...mapGetters(systemGroupModel, [
      'membershipCount',
    ]),
  },

  async mounted() {
    await this.fetchMembership(this.item.id);
    this.numberOfDevices = this.membershipCount;
  },

  methods: {
    ...mapActions(systemGroupModel, [
      'fetchMembership',
    ]),
  },
};
</script>

<style scoped module>
.deviceNumber {
  margin: auto 0;
}
</style>
